var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"my-6 mx-auto",staticStyle:{"max-width":"1500px"}},[_c('EeljTable',{attrs:{"item":{ name: 'Xичээлийн ээлжийн цаг', fbpath: 'xeelj' }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }